var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6154 4.73942C23.9733 4.38162 24.398 4.09779 24.8655 3.90415C25.333 3.71051 25.8341 3.61084 26.3401 3.61084C26.8461 3.61084 27.3472 3.71051 27.8146 3.90415C28.2821 4.09779 28.7069 4.38162 29.0647 4.73942C29.4225 5.09723 29.7064 5.522 29.9 5.9895C30.0936 6.45699 30.1933 6.95805 30.1933 7.46406C30.1933 7.97007 30.0936 8.47113 29.9 8.93862C29.7064 9.40612 29.4225 9.83089 29.0647 10.1887L10.6734 28.58L3.18066 30.6235L5.22414 23.1307L23.6154 4.73942Z",
    stroke: "#5B5B5B",
    strokeWidth: 2.72464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5b0774d92c84c7438ece8e5aca096613.svg";
export { ForwardRef as ReactComponent };